export default async function ({ store, redirect, params }) {
  if (!store.state.user.is_staff) {
    if (!store.getters["user/IS_INF"]) return redirect("/")
    else if (store.state.user.influencer.slug !== params.slug)
      return redirect(`/influencer/profile/${params.slug}/`)
  }
  try {
    await Promise.all([
      store.dispatch("tag/FETCH"),
      store.dispatch(
        "user/influencer/tags/FETCH",
        store.state.user.is_staff ? params.slug : undefined
      ),
    ])
  } catch (error) {
    console.error(error)
  }
}
